(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kichu-offer-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('kichu-offer-slider')) return;

    class KichuOfferSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ko-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.children);
        this.prevBtn = this.querySelector('[data-ko-prev]');
        this.nextBtn = this.querySelector('[data-ko-next]');
        this.dotsWrap = this.querySelector('[data-ko-dots]');

        this.autoplay = this.dataset.autoplay === 'true';
        this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
        this.loop = this.dataset.loop === 'true';
        this.pauseOnHover = this.dataset.pauseHover === 'true';
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.index = 0;
        this.stops = [0];
        this.paused = false;
        this.inView = true;
        this.timer = null;
        this.ticking = false;

        this.onScroll = this.onScroll.bind(this);
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);
        this.onClickCapture = this.onClickCapture.bind(this);
        this.onVisibility = () => { if (!document.hidden) this.restart(); };
        this.onBlockSelect = this.onBlockSelect.bind(this);
        this.onBlockDeselect = this.onBlockDeselect.bind(this);

        if (this.prevBtn) this.prevBtn.addEventListener('click', () => { this.goTo(this.index - 1); this.restart(); });
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => { this.goTo(this.index + 1); this.restart(); });

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('click', this.onClickCapture, true);
        this.track.addEventListener('dragstart', (e) => e.preventDefault());
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.goTo(this.index + 1); this.restart(); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.goTo(this.index - 1); this.restart(); }
        });

        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', () => { this.paused = true; });
          this.addEventListener('mouseleave', () => { this.paused = false; });
        }
        this.addEventListener('focusin', () => { this.paused = true; });
        this.addEventListener('focusout', () => { this.paused = false; });
        this.track.addEventListener('touchstart', () => { this.paused = true; }, { passive: true });
        this.track.addEventListener('touchend', () => {
          clearTimeout(this.touchTimer);
          this.touchTimer = setTimeout(() => { this.paused = false; }, 2500);
        }, { passive: true });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.update());
          this.ro.observe(this.track);
        } else {
          window.addEventListener('resize', () => this.update());
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver((entries) => {
            this.inView = entries[0].isIntersecting;
          }, { threshold: 0.2 });
          this.io.observe(this);
        }

        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

        this.update();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.ro) this.ro.disconnect();
        if (this.io) this.io.disconnect();
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }

      get maxScroll() {
        return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      }

      computeStops() {
        const max = this.maxScroll;
        const base = this.slides[0] ? this.slides[0].offsetLeft : 0;
        const stops = [];
        for (const slide of this.slides) {
          const left = slide.offsetLeft - base;
          if (left < max - 2) {
            stops.push(Math.round(left));
          } else {
            stops.push(Math.round(max));
            break;
          }
        }
        return stops.length ? stops : [0];
      }

      update() {
        this.stops = this.computeStops();
        this.classList.toggle('is-scrollable', this.maxScroll > 4);
        this.renderDots();
        this.syncIndex();
      }

      renderDots() {
        if (!this.dotsWrap) return;
        if (this.dotsWrap.childElementCount === this.stops.length) return;
        this.dotsWrap.innerHTML = '';
        this.stops.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ko-dot';
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          dot.addEventListener('click', () => { this.goTo(i); this.restart(); });
          this.dotsWrap.appendChild(dot);
        });
      }

      syncIndex() {
        const x = this.track.scrollLeft;
        let best = 0;
        let dist = Infinity;
        this.stops.forEach((stop, i) => {
          const d = Math.abs(stop - x);
          if (d < dist) { dist = d; best = i; }
        });
        this.index = best;

        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((dot, i) => {
            const active = i === best;
            dot.classList.toggle('is-active', active);
            if (active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }
        if (!this.loop) {
          if (this.prevBtn) this.prevBtn.disabled = best === 0;
          if (this.nextBtn) this.nextBtn.disabled = best >= this.stops.length - 1;
        }
      }

      onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.ticking = false;
          this.syncIndex();
        });
      }

      goTo(i) {
        const n = this.stops.length;
        if (!n) return;
        if (i < 0) i = this.loop ? n - 1 : 0;
        if (i >= n) i = this.loop ? 0 : n - 1;
        this.index = i;
        this.track.scrollTo({ left: this.stops[i], behavior: this.reduced ? 'auto' : 'smooth' });
      }

      start() {
        this.stop();
        if (!this.autoplay || this.reduced || this.stops.length < 2) return;
        this.timer = setInterval(() => {
          if (this.paused || !this.inView || document.hidden || this.dragging) return;
          if (this.index >= this.stops.length - 1) this.goTo(0);
          else this.goTo(this.index + 1);
        }, this.speed);
      }

      stop() {
        clearInterval(this.timer);
        this.timer = null;
      }

      restart() {
        if (this.autoplay) this.start();
      }

      /* Mouse drag (touch uses native swipe) */
      onPointerDown(e) {
        if (e.pointerType !== 'mouse' || e.button !== 0 || this.maxScroll <= 4) return;
        this.dragging = true;
        this.moved = false;
        this.startX = e.clientX;
        this.startScroll = this.track.scrollLeft;
        window.addEventListener('pointermove', this.onPointerMove);
        window.addEventListener('pointerup', this.onPointerUp);
      }

      onPointerMove(e) {
        if (!this.dragging) return;
        const dx = e.clientX - this.startX;
        if (!this.moved && Math.abs(dx) > 5) {
          this.moved = true;
          this.track.classList.add('is-dragging');
        }
        if (this.moved) this.track.scrollLeft = this.startScroll - dx;
      }

      onPointerUp() {
        window.removeEventListener('pointermove', this.onPointerMove);
        window.removeEventListener('pointerup', this.onPointerUp);
        if (!this.dragging) return;
        this.dragging = false;
        if (this.moved) {
          this.track.classList.remove('is-dragging');
          this.syncIndex();
          this.goTo(this.index);
          this.restart();
        }
      }

      onClickCapture(e) {
        if (this.moved) {
          e.preventDefault();
          e.stopPropagation();
          this.moved = false;
        }
      }

      /* Theme editor: jump to the slide being edited */
      onBlockSelect(e) {
        if (!this.contains(e.target)) return;
        const slide = e.target.closest('.ko-slide');
        const i = this.slides.indexOf(slide);
        if (i < 0) return;
        this.paused = true;
        this.update();
        this.goTo(Math.min(i, this.stops.length - 1));
      }

      onBlockDeselect(e) {
        if (!this.contains(e.target)) return;
        this.paused = false;
      }
    }

    customElements.define('kichu-offer-slider', KichuOfferSlider);
  })();

  } catch(e) { console.error(e); }
})();
})();
